import { render, staticRenderFns } from "./RedEnvelopeDemo.vue?vue&type=template&id=c2b8db30&scoped=true&"
import script from "./RedEnvelopeDemo.vue?vue&type=script&lang=ts&"
export * from "./RedEnvelopeDemo.vue?vue&type=script&lang=ts&"
import style0 from "./RedEnvelopeDemo.vue?vue&type=style&index=0&id=c2b8db30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b8db30",
  null
  
)

export default component.exports